import React from "react";
import { getStoredLocale, translate } from "../lib/i18n";
import { logger } from "../lib/logger";

type Props = { children: React.ReactNode };
type State = { error: Error | null };

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    logger.error("react.error_boundary", {
      message: error.message,
      stack: error.stack,
      componentStack: info.componentStack,
    });
  }

  render() {
    if (this.state.error) {
      const locale = getStoredLocale();
      return (
        <div style={{ padding: 24, color: "#f87171", background: "#0b0d12", height: "100vh" }}>
          {/* Preflight zeroes UA heading weight and `pre` margins: restored as utilities.
              The retry button uses the shared `sc-page-btn` primitive (Preflight strips the
              native button look); the inline size wins over the primitive's. */}
          <h2 className="font-bold" style={{ margin: "0 0 8px", fontSize: 16 }}>
            {translate(locale, "error.boundary")}
          </h2>
          <pre className="my-[1em]" style={{ fontSize: 11, whiteSpace: "pre-wrap", color: "#fca5a5" }}>
            {this.state.error.message}
          </pre>
          <p style={{ fontSize: 11, color: "#64748b", marginTop: 12 }}>
            {translate(locale, "error.detailsLog")}
          </p>
          <button
            type="button"
            className="sc-page-btn"
            style={{ marginTop: 8, fontSize: 11, padding: "4px 10px" }}
            onClick={() => this.setState({ error: null })}
          >
            {translate(locale, "error.retry")}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
